<template>
  <el-card class="box-card list-profit">
    <el-row class="mb-10">
      <el-col :span="12" class="table-quantity-data">
        <span class="mr-20 font-weight-700">{{ title }}</span>
        <span class="close" @click="handleShow">{{ !showList ? $t('profits.open') :  $t('profits.close') }}</span>
      </el-col>
      <el-col :span="12" class="text-right">
        <span class="btn-export" @click="exportData">{{ $t('profits.btn_export') }}</span>
      </el-col>
    </el-row>
    <hr/>
    <div v-if="showList">
      <el-table :data="data.records"
        id="table"
        class="mt-20"
        v-loading="loading"
        :empty-text="$t('table.no_data')"
        @sort-change="sortChange"
      >
        <el-table-column v-for="(column, index) in columns"
          :key="index"
          :label="column.label"
          :sortable="column.sortable"
          :class-name="column.class"
          :prop="column.prop"
          :width="column.width"
          :label-class-name="column.labelClass"
          :align="column.align"
        >
          <template v-slot="scope">
            <p v-html="scope.row[column.prop]"></p>
          </template>
        </el-table-column>
      </el-table>
      <p class="table-quantity-data padding-top-list text-center">
        {{ $t('quantity_item_is_showing_table_footer', [data.total, recordStart, recordEnd]) }}
      </p>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="data.total" :page-size="data.perPage"
        prev-text="＜ 前へ" next-text="次へ ＞"
        :currentPage="data.currentPage"
        @current-change="handleChangePage"
      />
      <div class="condition-search-text-profit bottom">
        <el-row>
          <el-col :span="24" class="font-weight-700">{{ $t('profits.search_result', [searchConditionText.result])}}</el-col>
        </el-row>
        <div v-for="(item, index) in searchConditionText.condition" :key="index">
          {{ item }}
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
  export default {
    props: {
      title: { type: String, required: true, default: '' },
      columns: { type: Array, required: true, default: [] },
      data: { type: Object, required: true, default: [] },
      loading: { type: Boolean, required: true, default: true },
      searchConditionText: { type: Object, required: true, default: [] },
      showList: { type: Boolean, required: true, default: true },
    },
    emits: ['changePage', 'clickButton', 'sort', 'clickLink', 'exportData', 'handleShow'],
    data() {
      return {
      }
    },
    methods: {
      handleChangePage(page) {
        this.$emit('changePage', page);
      },

      sortChange(sortProps) {
        this.$emit('sort', sortProps);
      },

      handleShow() {
        this.$emit('handleShow');
      },

      exportData() {
        this.$emit('exportData');
      }
    },

    computed: {
      recordStart() {
        return (this.data.total > 0) ? (this.data.currentPage - 1) * this.data.perPage + 1 : 0;
      },

      recordEnd() {
        const temp = this.data.currentPage * this.data.perPage;
        return (temp >= this.data.total) ? this.data.total : temp;
      },
    },
  }
</script>
<style lang="scss">
  .list-profit {
    margin-bottom: 50px;
    .btn-export {
      font: normal normal normal 12px/26px Kozuka Gothic Pr6N;
      letter-spacing: 1.2px;
      color: #17609F;
      cursor: pointer;
    }

    .limit-text {
      p {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow:hidden;
        margin: 0;
      }
    }

    .staff-name {
      text-decoration: underline;
      font: normal normal normal 11px/24px Kozuka Gothic Pr6N;
      letter-spacing: 1.1px;
      color: #17609F;
    }
  }
</style>
